define('SuiteCommerce.OrderStatus.Utils', [
	'SuiteCommerce.OrderStatus.Configuration',
	'Handlebars',
	'underscore',
], function define(Configuration, Handlebars, _) {
	'use strict';
	var CONFIGURATION_SUBTAB_ID = 'orderstatus';
	var PURCHASES_HASHTAG = '#/purchases';
	var PURCHASE_DETAILS_ROUTE = '#/purchases/view/';
	function getConfigurationParameter(parameter) {
		return Configuration.get(CONFIGURATION_SUBTAB_ID + '.' + parameter);
	}
	function getEnvironmentSession() {
		if (Configuration.environment && Configuration.environment.getSession) {
			return Configuration.environment.getSession() || {};
		}
		return {};
	}
	function getUserProfileComponent() {
		return Configuration.getUserProfile();
	}
	function getLoginStateFromProfile(profile) {
		if (!profile) {
			return null;
		}
		if (typeof profile.isloggedin !== 'undefined') {
			return !!profile.isloggedin && profile.isrecognized !== true;
		}
		if (typeof profile.isguest !== 'undefined') {
			return !profile.isguest;
		}
		return null;
	}
	function resolveIsUserLoggedIn() {
		var userProfileComponent = getUserProfileComponent();
		var userProfile;
		if (!userProfileComponent || !userProfileComponent.getUserProfile) {
			return Promise.resolve(false);
		}
		try {
			userProfile = userProfileComponent.getUserProfile();
		} catch (error) {
			return Promise.resolve(false);
		}
		if (!userProfile || !userProfile.then) {
			return Promise.resolve(!!getLoginStateFromProfile(userProfile));
		}
		return userProfile
			.then(function (userProfileData) {
				var loginState = getLoginStateFromProfile(userProfileData);
				if (loginState === null) {
					return false;
				}
				return loginState;
			})
			.catch(function () {
				return false;
			});
	}
	function getQueryParameters() {
		var searchString;
		var queryParameters = {};
		if (typeof window === 'undefined' || !window.location || !window.location.search) {
			return queryParameters;
		}
		searchString = window.location.search.replace(/^\?/, '');
		if (!searchString) {
			return queryParameters;
		}
		_.each(searchString.split('&'), function parseQueryStringEntry(queryStringEntry) {
			var queryStringEntryParts;
			var key;
			var value;
			if (!queryStringEntry) {
				return;
			}
			queryStringEntryParts = queryStringEntry.split('=');
			key = decodeURIComponent(queryStringEntryParts.shift() || '');
			value = decodeURIComponent((queryStringEntryParts.join('=') || '').replace(/\+/g, ' '));
			if (key) {
				queryParameters[key] = value;
			}
		});
		return queryParameters;
	}
	function getPurchasesHashtag() {
		return PURCHASES_HASHTAG;
	}
	function getPurchaseDetailsHashtag(orderType, orderId) {
		if (!orderId) {
			return PURCHASES_HASHTAG;
		}
		return (
			PURCHASE_DETAILS_ROUTE + encodeURIComponent(orderType || 'salesorder') + '/' + encodeURIComponent(orderId)
		);
	}
	function getCustomerCenterUrl(hashtag) {
		var touchpoints = Configuration.getSiteSetting('touchpoints') || {};
		var customerCenterUrl = touchpoints.customercenter || '';
		var customerCenterHashtag = hashtag || PURCHASES_HASHTAG;
		var normalizedCustomerCenterUrl;
		if (!customerCenterUrl) {
			return customerCenterHashtag;
		}
		normalizedCustomerCenterUrl = customerCenterUrl.split('#')[0];
		return normalizedCustomerCenterUrl + customerCenterHashtag;
	}
	function redirectToCustomerCenter(hashtag) {
		if (typeof window === 'undefined' || !window.location) {
			return;
		}
		window.location.href = getCustomerCenterUrl(hashtag);
	}
	function registerHandlevarsHelpers() {
		Handlebars.registerHelper('equals', function registerHelper(value1, value2, conf) {
			if (value1 === value2) {
				return conf.fn(this);
			}
			return conf.inverse(this);
		});
		Handlebars.registerHelper('isgreaterthan', function registerHelper(value1, value2, conf) {
			if (value1 > value2) {
				return conf.fn(this);
			}
			return conf.inverse(this);
		});
		Handlebars.registerHelper('islessthan', function registerHelper(value1, value2, conf) {
			if (value1 < value2) {
				return conf.fn(this);
			}
			return conf.inverse(this);
		});
	}
	// eslint-disable-next-line complexity
	function formatCurrency(value, symbol, noDecimalPosition) {
		var valueFloat = parseFloat(value);
		var negative = valueFloat < 0;
		var groupSeparator = ',';
		var decimalSeparator = '.';
		var negativePrefix = '(';
		var negativeSuffix = ')';
		var thousandString = '';
		var beforeValue = true;
		var valueString;
		var decimalPosition;
		var i;
		var symbolWrapper = symbol;
		// eslint-disable-next-line no-restricted-globals
		if (isNaN(valueFloat)) {
			return value;
		}
		valueFloat = parseInt('' + (Math.abs(valueFloat) + 0.005) * 100, 10) / 100;
		valueString = valueFloat.toString();
		groupSeparator = Configuration.getSiteSetting('groupseparator');
		decimalSeparator = Configuration.getSiteSetting('decimalseparator');
		negativePrefix = Configuration.getSiteSetting('negativeprefix');
		negativeSuffix = Configuration.getSiteSetting('negativesuffix');
		valueString = valueString.replace('.', decimalSeparator);
		decimalPosition = valueString.indexOf(decimalSeparator);
		// if the string doesn't contains a .
		if (decimalPosition === -1) {
			if (!noDecimalPosition) {
				valueString += decimalSeparator + '00';
			}
			decimalPosition = valueString.indexOf(decimalSeparator);
		} else if (valueString.indexOf(decimalSeparator) === valueString.length - 2) {
			// if it only contains one number after the .
			valueString += '0';
		}
		for (i = valueString.length - 1; i >= 0; i -= 1) {
			// If the distance to the left of the decimal separator is a multiple
			// of 3 you need to add the group separator
			thousandString =
				(i > 0 && i < decimalPosition && (decimalPosition - i) % 3 === 0 ? groupSeparator : '') +
				valueString[i] +
				thousandString;
		}
		if (!symbolWrapper) {
			symbolWrapper = '$';
		}
		valueString =
			beforeValue || _.isUndefined(beforeValue) ? symbolWrapper + thousandString : thousandString + symbolWrapper;
		return negative ? negativePrefix + valueString + negativeSuffix : valueString;
	}
	return {
		getConfigurationParameter: getConfigurationParameter,
		getCustomerCenterUrl: getCustomerCenterUrl,
		getPurchaseDetailsHashtag: getPurchaseDetailsHashtag,
		getPurchasesHashtag: getPurchasesHashtag,
		getQueryParameters: getQueryParameters,
		formatCurrency: formatCurrency,
		resolveIsUserLoggedIn: resolveIsUserLoggedIn,
		redirectToCustomerCenter: redirectToCustomerCenter,
		registerHandlevarsHelpers: registerHandlevarsHelpers,
	};
});
